import React, {useRef, useState, useEffect} from "react";
import {ReactFlowProvider, MarkerType} from "@xyflow/react";
import '@xyflow/react/dist/style.css';
import FlowchartStep from "./CustomFlowComponents/FlowchartStepNode";
import CustomEdge from "./CustomFlowComponents/CustomEdge";
import FlowchartColumn from './CustomFlowComponents/FlowchartColumnNode'
import mockFlow from '../../Common/scotPlacemat/flow';
import ReactFlowComponent from "../../Common/scotPlacemat/ReactFlowComponent";
import {getFlow, setUp} from '../../Common/scotPlacemat/flowUtils';
import styled from 'styled-components';
import calculateNewChart from '../../Common/scotPlacemat/calculateNewChart'

const nodeTypes = {
  FlowchartStep: FlowchartStep,
  FlowchartColumn: FlowchartColumn
}
const edgeTypes = {
  'custom-edge': CustomEdge,
};

const SeahawksDrydock = () => {
  const instanceRef = useRef(null);
  $('.MainContainerWrapper').removeClass('left-margin');
  const [chart, setChart] = useState(null);

  useEffect(()=>{
    const flow= setUp(mockFlow)
    setChart(flow)
  },[])

  const markerEnd = {
    type: MarkerType.ArrowClosed,
    width: 20,
    height: 20,
    color: '#FF0072',
  }

  
  const saveFlow = (instanceRef) => {
    const isPreview= true
    const newChart= getFlow(instanceRef,isPreview);
    console.log('newChart', newChart);
    setChart(newChart);
    const chartForApi = getFlow(instanceRef)
    console.log('chartForApi', chartForApi)
  }

  const addNode = (parentId) => {
    const latestChart= getFlow(instanceRef, true);
    const newChart= calculateNewChart(parentId, latestChart)
    setChart(newChart)
  }

  return (
    <>
    <h1>Seahawks Drydock</h1>
    <ReactFlowProvider>
    <ButtonDiv position="top-right" className="PanelStyles">
        <button onClick={()=>saveFlow(instanceRef)}>Save</button>
        <button onClick={()=>addNode('8a26c963-8b3e-4289-8f1a-a546f40e8950')}>Add C1</button>
        <button onClick={()=>addNode('7f44404f-2ba7-414a-b946-8cf36d4c2077')}>Add C2</button>
        <button onClick={()=>addNode('78f4d4da-a2f8-4674-834e-0528d5463552')}>Add C3</button>
        <button onClick={()=>addNode('8df91070-1224-4357-b440-a70724d5a588')}>Add C4</button>
      </ButtonDiv>
    {chart? <ReactFlowComponent saveFlow={saveFlow} nodeTypes={nodeTypes} edgeTypes={edgeTypes} edgeComponent={CustomEdge} data={chart} initRef={instanceRef} columnWidth= {420} offsetX={10} markerEnd={markerEnd}/> : null}
    </ReactFlowProvider>
    </>
  )
}

export default SeahawksDrydock;

const ButtonDiv = styled.div`
  button {
    background-color: #000;
    color: #fff;
    border-radius: 5px;
    padding: 5px;
    margin: 5px;
    border: none;
    width: 100px;
    font-size: 12px;
  }
`